import { render, staticRenderFns } from "./UpdateNetlinkType.vue?vue&type=template&id=6b3b6b8e&scoped=true"
import script from "./UpdateNetlinkType.vue?vue&type=script&lang=js"
export * from "./UpdateNetlinkType.vue?vue&type=script&lang=js"
import style0 from "./UpdateNetlinkType.vue?vue&type=style&index=0&id=6b3b6b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b6b8e",
  null
  
)

export default component.exports